/**
 * Allow only same-origin relative paths (no protocol-relative //host, backslash, or @ tricks).
 */
export function safeRedirectPath(from: unknown, fallback = '/dashboard'): string {
  let raw = '';
  if (typeof from === 'string') {
    raw = from;
  } else if (from && typeof from === 'object' && 'pathname' in from) {
    const pathname = (from as { pathname?: unknown }).pathname;
    if (typeof pathname === 'string') raw = pathname;
  }

  if (!raw) return fallback;

  let decoded = raw;
  try {
    decoded = decodeURIComponent(raw);
  } catch {
    return fallback;
  }

  if (!decoded.startsWith('/')) return fallback;
  if (decoded.startsWith('//') || decoded.startsWith('/\\')) return fallback;
  if (decoded.includes('\\') || decoded.includes('@')) return fallback;
  if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(decoded.slice(1))) return fallback;

  const pathOnly = decoded.split('?')[0].split('#')[0];
  if (!/^\/[A-Za-z0-9._~/-]*$/.test(pathOnly)) return fallback;
  return pathOnly || fallback;
}
